import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {User} from 'src/app/core/model/user';
import {OphAvatarComponent} from 'src/app/shared/design/oph-avatar/oph-avatar.component';
import {PipesModule} from 'src/app/shared/pipes/pipes.module';

@Component({
  selector: 'task-dialog-requirement-item',
  standalone: true,
  imports: [CommonModule, OphAvatarComponent, PipesModule],
  templateUrl: './task-dialog-requirement-item.component.html',
  styleUrls: ['./task-dialog-requirement-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskDialogRequirementItemComponent {
  @Input() selected: boolean;
  @Input() type: 'people' | 'teams' | 'skills';
  @Input() display: string;
  @Input() user: User;
  @Input() buttonWidth: string;

  @Output() buttonClick = new EventEmitter<boolean>();
}
